import socketIOClient from "socket.io-client";

let socket = null;

export const getSocket = () => {
    if (!socket) {
        const TOKEN = sessionStorage.getItem("token");
        socket = socketIOClient(process.env.REACT_APP_SERVER_URL, {
            query: { token: TOKEN },
        });
    }
    return socket;
};

export const disconnectSocket = () => {
    if (socket) {
        socket.disconnect();
        socket = null;
    }
};
